export type ResponseTemplate = {
  id: number;
  name: string;
};

export type ResponseOrder = {
  message: string;
};

export interface TemplatesMixin {
  fetch(path: string, init?: RequestInit): Promise<any>;
  getTemplate(sessionId: number): Promise<ResponseTemplate>;
  orderSections(
    sessionId: number,
    templateId: number,
    init: number,
    final: number
  ): Promise<ResponseOrder>;
}
export const TemplatesMixin = {
  async fetch(path: string, init?: RequestInit): Promise<any> {
    throw new Error('Not implemented');
  },
  async getTemplate(sessionId: number): Promise<ResponseTemplate> {
    const template = await this.fetch(`/sessions/${sessionId}/templates`, { method: 'get' });
    return template;
  },
  async orderSections(
    sessionId: number,
    templateId: number,
    init: number,
    final: number
  ): Promise<ResponseOrder> {
    const order = await this.fetch(`/sessions/${sessionId}/templates/${templateId}/order`, {
      method: 'post',
      body: JSON.stringify({
        init,
        final,
      }),
    });
    return order;
  },
} as TemplatesMixin;
